module.exports = __webpack_public_path__ + "img/meto-logo-phone.e8905551.png";